"use client";

import MediaInputProvider from "@/providers/media-input-provider/media-input-provider";
import { beatMachineSessionStorage } from "@/services/storage/beat-machine-session-storage";
import { beatMachineLicenseManager } from "@/services/license/license-managers/beat-machine-license-manager";
import WavesurferProvider from "@/hooks/providers/wavesurfer-provider";
import BeatsPage from "@/components/pages/beats/beats-page";

const BeatsMachine = () => {
  return (
    <MediaInputProvider
      sessionStorage={beatMachineSessionStorage}
      licenseManager={beatMachineLicenseManager}
    >
      <WavesurferProvider>
        <BeatsPage />
      </WavesurferProvider>
    </MediaInputProvider>
  );
};

export default BeatsMachine;
